import styles from "./EventSchedule.module.scss";

export const EventSchedule = ({ items = [] }) => {
  const formatExperts = (experts = []) => {
    if (!experts.length) return "";
    if (experts.length === 1) return experts[0];
    if (experts.length === 2) return `${experts[0]} и ${experts[1]}`;

    return `${experts.slice(0, -1).join(", ")} и ${experts[experts.length - 1]}`;
  };

  return (
    <div>
      {items.map((item, index) => (
        <div className={styles.itemContainer} key={item.id ?? index}>
          <div className={styles.itemContainer__time}>
            {item.startTime && item.endTime ? (
              <>
                {item.startTime} - {item.endTime}
              </>
            ) : (
              <></>
            )}
          </div>

          <div className={styles.itemContainer__infoBlock}>
            {item.image && (
              <div className={styles.itemContainer__imgBlock}>
                <img
                  src={item.image}
                  alt={item.title}
                  className={styles.itemContainer__img}
                />
              </div>
            )}

            <div className={styles.itemContainer__textBlock}>
              <p className={styles.itemContainer__title}>{item.title}</p>
              {item.experts?.length > 0 && (
                <p className={styles.itemContainer__subTitle}>
                  {formatExperts(item.experts)}
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
